import { useEffect } from "react"
import { useOutletContext } from "react-router-dom"
import MyCalendar from "~/components/planning/views/MyCalendar"

export default function Index() {

    const [pageTitle, setPageTitle] = useOutletContext()

    useEffect(() => {
        setPageTitle("Accueil")
    }, [])

    return (
    <div className="w-full flex flex-col justify-center content-center">
        <div className="text-center"><MyCalendar />
        </div>
    </div>
    )
}